export const styles = {
    editButton: {
        position: 'absolute',
        bottom: 20,
        left: 20,
        zIndex: [4, '!important']
    }
};
